// extracted by mini-css-extract-plugin
export default {"container":"uT-z","title":"vT-z","link":"wT-z"};